/**
 * This file is categorized as "Proprietary Framework Code"
 * and is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
import {
	Row,
} from 'native-base';

export default function Toolbar(props) {
	return <Row
				p={2}
				justifyContent="center"
				bg="trueGray.200"
				borderBottomWidth={1}
				borderBottomColor="trueGray.400"
				{...props}
			>
				{props.children}
			</Row>;
};
